import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';


const CommentsSection: FC = () => {
	const { width } = useResizeObserver();
	const { transData, list } = useTranslation('prices.comments');
	const itemList = list.map((item, index) => {
		return (
			<div
				className={classnames(styles['ac-prices-comment-item'], styles[`ac-prices-comment-item-${item.id}`], `ac-prices-comment-item-${item.id}`)}
				key={index}>
				<div className={styles['ac-prices-comment-avatar']}>
					<span className={styles['ac-prices-comment-name']}>{item.name}</span>
				</div>
				<div className={styles['ac-prices-comment-icon']}>
					{Array.from({ length: 5 }).map((_, i) => {
						return (
							<img loading='lazy'
								src={'https://web-data.zmlearn.com/image/7HZreMNGHR1ABea7JNAnqU/icon_star%402x.png'} alt=''
								key={i} />
						);
					})}
				</div>
				<div className={styles['ac-prices-comment-item-context']}>
					<p>{item.content}</p>
					<span className={styles['date']}>{item.date}</span>
				</div>
			</div>);
	});
	const phoneBetween = width < 768 ? 16 : 0;
	const spaceBetween = width >= 1192 ? 24 : phoneBetween;
	return (
		<section className={styles['ac-prices-comment']}>
			<div className={styles['ac-prices-comment-container']}>
				<img className={styles['ac-prices-comment-img-1']} loading='lazy'
					src='https://web-data.zmlearn.com/image/uhTNQvdTQhvJRcxwGactJn/img_P4_left%402x.png' alt='' />
				<img className={styles['ac-prices-comment-img-2']} loading='lazy'
					src='https://web-data.zmlearn.com/image/qeLATnjjH7UAWjrzK1mveV/img_P4_right%402x.png' alt='' />
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<div className={styles['comment-wrap']}>
					<span className={styles['excellent']}>{transData.excellent}</span>
					<div className={styles['icon']}>
						{Array.from({ length: 4 }).map((_, i) => {
							return (
								<img loading='lazy'
									src={'https://web-data.zmlearn.com/image/m1wmPMVF4uNW2VoexECuyT/icon_starface%402x.png'} alt=''
									key={i} />
							);
						})}
						<img loading='lazy' src={'https://web-data.zmlearn.com/image/seHxeArE1U7Sy6zHYpBzVf/icon_face%402x.png'}
							alt='' />
					</div>
					<span className={styles['reviews']}>{transData.reviews}</span>
				</div>
				<AcSwipe className={classnames(styles['ac-prices-comment-banner'], 'ac-prices-comment-banner')}
					loop
					pagination={{ clickable: true }}
					// autoplay={{
					// 	delay: 5000,
					// 	disableOnInteraction: false,
					// }}
					slidesPerGroup={width >= 768 ? 3 : 1}
					loopFillGroupWithBlank={width >= 768}
					slidesPerView={width >= 768 ? 3 : 'auto'}
					spaceBetween={spaceBetween}
					centeredSlides
				>{itemList}</AcSwipe>

			</div>
		</section>
	);
};

export default CommentsSection;
